import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import styles from './Spinner.module.sass'

export default function Spinner({ color }) {
  const classes = {
    [styles.ldsDefault]: true,
    [styles[color]]: true,
  }
  return (
    <div className={cn(classes)}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  )
}

Spinner.defaultProps = {
  color: 'white',
}

Spinner.propTypes = {
  color: PropTypes.oneOf(['white', 'blue']),
}
